import { render, staticRenderFns } from "./RevisionSelectorModal.vue?vue&type=template&id=0fdf7e18"
import script from "./RevisionSelectorModal.vue?vue&type=script&lang=js"
export * from "./RevisionSelectorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports